import { redirect } from 'react-router';

import { BaseUrlRoute, PersonsRoute, TabletLoginRoute } from '@/config/router/routes';
import { ServerAddress } from '@/utils/serverAddress';
import { StorageHelper } from '@/utils/storageHelper';

/**
 * Страж экранов посетителя — аватаров, языка и чата. Как в APK: пока
 * у планшета нет сессии, киоск спрашивает пароль; токены, однажды
 * полученные в этом браузере, пускают сразу.
 *
 * Экраны администратора (адрес, PIN, журнал) страж не трогает: через них
 * планшет и получает сессию — верный PIN тоже выдаёт токены.
 *
 * Это граница интерфейса, а не защита данных: закрывать API от чужих
 * запросов должен бекенд.
 */

/** Куда увести вместо экрана посетителя; `null` — пускать. */
export function tabletSessionRedirect(): string | null {
  const storage = StorageHelper.instance;
  const baseUrl = storage.baseUrl;
  // Адреса нет — входить не во что: его вводит администратор.
  if (baseUrl === null) return BaseUrlRoute.location();
  // Сервер без планшетов (адрес без slug'а): пароля у такого нет.
  if (!ServerAddress.parse(baseUrl).hasPath) return null;
  return storage.hasTabletSession(baseUrl) ? null : TabletLoginRoute.location;
}

/** `loader` защищённого маршрута: перенаправление или `null`. */
export function requireTabletSession(): Response | null {
  const location = tabletSessionRedirect();
  return location === null ? null : redirect(location);
}

/**
 * `loader` экрана пароля: уводит с него, когда пароль не нужен. Адрес
 * `/tablet-login` браузер восстанавливает после перезапуска, его же могут
 * прописать стартовым — с живой сессией он не должен спрашивать снова.
 */
export function tabletLoginRedirect(): Response | null {
  const target = tabletSessionRedirect();
  if (target === TabletLoginRoute.location) return null;
  return redirect(target ?? PersonsRoute.location);
}
